export enum StatusEnum {
  Active = "Active",
  Inactive = "Inactive",
}
